export const getCustomFieldsActivationPendingKey = (companyId: string) =>
  `spx:custom-fields-activation-pending:${companyId}`;

export const SESSION_EXPIRE_LOCAL_STORAGE_KEY = 'spx:last-activity-tracker';

export const LANG_LOCAL_STORAGE_KEY = 'spx:lang';

export const LAST_REMINDER_LOCAL_STORAGE_KEY =
  'spx:app-desktop:last-reminder-modal';

export const LAST_ACCOUNTING_SETTINGS_REFRESH =
  'spx:app-desktop:last-accounting-settings-refresh';

export const LAST_SERVER_STATUS_REFRESH =
  'spx:app-desktop:last-server-status-refresh';

export enum LocalStorageKey {
  /* eslint-disable @typescript-eslint/naming-convention */
  AutocatUpsellCalloutClosedDate = 'autocat-upsell-callout-closed-date',
  AutocatUpsellCalloutClosureCount = 'autocat-upsell-callout-closure-count',
  DismissSwitchToMobileAppPopup = 'dismissSwitchToMobileAppPopup',
  ExpandNavigation = 'expand-navigation',
  PayableRulesProductTour = 'payable-rules-product-tour',
  PayableRulesGroupTooltip = 'payable-rules-group-tooltip',
  InvitationToken = 'invitation-token',
  LastOnboardingSectionOpened = 'last-onboarding-section-opened',
  LastSupervisedUserId = 'last-supervised-user-id',
  LastSupervisedUserName = 'last-supervised-user-name',
  LastUsedExportTemplate = 'last-used-export-template',
  LastUsedExportTemplateV2 = 'last-used-export-template-v2',
  MultiEntityHubIntroModalEncountered = 'organisation-reporting-intro-modal-encountered',
  MultiEntityHubPinnedEntities = 'organisation-reporting-pinned-entities',
  MyCardMobileBannerDismissed = 'my-card-mobile-banner-dismissed',
  OnboardingHubWelcomeAdminModalDismissed = 'onboarding-hub-welcome-admin-modal-dismissed',
  SetupHubCompletionModalShown = 'setup_hub_completion_modal_shown',
  PayablesCreationDateHiddenCallout = 'payables-creation-date-hidden-callout',
  PayablesInvoiceNumberHiddenCallout = 'payables-invoice-number-hidden-callout',
  SfsEmptyBankAccountCodeExport = 'sfs-empty-bank-account-code-export',
  SpendLimitsProductTour = 'spend-limit-product-tour',
  ApprovalWorkflowTour = 'approval-workflow-tour',
  PriceUpdateBanner = 'price-update-banner',
  KycRemediationBannerControllerDismissed = 'kyc-remediation-banner-controller-dismissed',
  WiseIntegrationBannerDismissed = 'wise-integration-banner-dismissed',
  InternationalTransfersRemediatedMarketingBannerDismissed = 'international-transfers-remediated-marketing-banner-dismissed',
  IwtRemediateModalLastDisplayDate = 'international-transfers-remediate-modal-last-display-date',
  IwtRemediateBannerClosed = 'international-transfers-remediate-banner-closed',
  IwtRemediateTopBannerClosed = 'international-transfers-remediate-top-banner-closed',
  IwtAdoptionBannerClosed = 'international-transfers-adoption-banner-closed',
  IwtAdoptionModalClosedDate = 'international-transfers-adoption-modal-closed-date',
  IwtPostAdoptionModalClosedDate = 'international-transfers-post-adoption-modal-closed-date',
  PayableRulesMCRLimitBannerClosed = 'payable-rules-mcr-limit-banner-closed',
  ApprovalWorkflowView = 'approval-workflow-view',
  BookkeepView = 'bookkeep_view',
  GRAPES_THEME = 'grapes_theme',
  PrepareTableColumnOrder = 'prepare-table-column-order',
  InternationalTransfersPriceDropPopupClosed = 'international-transfers-price-drop-popup-closed',
  SingleUseCardsEducationalModalDismissed = 'single-use-cards-educational-modal-dismissed',
  SubscriptionsCardLimitsBannerDismissed = 'subscriptions-card-limits-banner-dismissed',
  /** @knipignore used with process.env.NODE_ENV === 'development' */
  __DEV_ONLY_me = 'dev-only:me',
  /* eslint-enable @typescript-eslint/naming-convention */
}

export enum SessionStorageKey {
  /* eslint-disable @typescript-eslint/naming-convention */
  CardActivated = 'card-activated',
  CheckYourBankStatement = 'ach:check-your-bank-statement:seen-modal',
  LastRejectedInvoiceToResubmitId = 'last-rejected-invoice-to-resubmit-id',
  /* eslint-enable @typescript-eslint/naming-convention */
}
